module.exports = __webpack_public_path__ + "static/img/s135.b25ac8f8.png";